import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { expireCookieSession, withoutSessionToken } from "../utils/auth-session";
export enum LoggedInSuperAdminKeys {
  SUPER_ADMIN_LOGGED_IN = "loggedInUser",
  ORGANISATION_DETAILS="organisationDetails",
  ORGANISATION_DATA='organisationTableData',
  ORG_USER_DATA='orgUserData'
}
@Injectable({
  providedIn: "root",
})
export class SuperAdminLoginService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) { }

  getLoggedInUser(key: LoggedInSuperAdminKeys) {
    const loggedIn = isPlatformBrowser(this.platformId)
      ? JSON.parse(localStorage.getItem(!key ? LoggedInSuperAdminKeys.SUPER_ADMIN_LOGGED_IN : key))
      : "";
    return loggedIn;
  }

  setLoggedInUser(key: LoggedInSuperAdminKeys, localStorageData) {
    const storageKey = key ? key : LoggedInSuperAdminKeys.SUPER_ADMIN_LOGGED_IN;
    // Same key as LoggedInUserService: with a cookie session the token stays out of storage.
    const data = storageKey === LoggedInSuperAdminKeys.SUPER_ADMIN_LOGGED_IN
      ? withoutSessionToken(localStorageData)
      : localStorageData;
    localStorage.setItem(storageKey, JSON.stringify(data));
  }
  removeLoggedInUser(key: LoggedInSuperAdminKeys) {
    localStorage.removeItem(key ? key : '');
  }
  clearEntireStorage() {
    localStorage.clear();
    sessionStorage.clear();
    expireCookieSession();
  }
}

